import React from 'react';
import Container from 'components/Container';
import styled from 'styled-components';
import {BasicBar} from 'components/Navigation/TopBar/BasicBar';
import tgPremium from 'media/tg-premium.png';
import logout from 'media/logout.svg';
import plus from 'media/plus.svg';
import PropTypes from 'prop-types';
import {path} from 'ramda';
import card from 'media/card.svg';
import mapIndexed from 'helpers/mapIndexed';
import {useTranslate} from 'helpers/translate';
import {ChevronRight, LogOut, Plus} from 'react-feather';
import {HISTORY_PATH, ROOT_PATH} from 'constants/routes';
import {useHistory} from 'react-router-dom';
import useFetch from "../../../../hooks/useFetch";
import {getBalanceAction} from "../../../../actions/user";
import * as STATES from "../../../../redux/reducers/states";
import formatNumber from "../../../../helpers/formatNumber";
import Loader from "../../../Loader";

const Bar = styled(BasicBar)`
  height: 75px;
  padding: 15px;
  display: flex;
  gap: 10px;
  flex-flow: row nowrap;
  align-items: center;
  background: #272780;
`

const Right = styled('div')`
`

const Photo = styled('div')`
  width: max-content;
  height: max-content;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  line-height: 29px;
  letter-spacing: -0.5px;
  color: #FFFFFF;

  & > img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 10px;
  }
`

const Name = styled('div')`
  display: flex;
  align-items: center;
  gap: 3px;
    
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: -0.5px;

  color: #FFFFFF;
    
  img {
    width: 15px;
    height: 15px;
  }
`

const Balance = styled('div')`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  gap: 5px;
  
  color: #fff;
`

const Menus = styled('div')`
  width: 100%;
  height: max-content;
`

const Menu = styled('div')`
  width: 100%;
  display: flex;
  height: 54px;
  align-items: center;
  border-bottom: 1px solid #DFE0E3;

  & p {
    margin-left: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 135%;
    letter-spacing: -0.005em;
    mix-blend-mode: normal;
  }

  position: relative;

  & > :last-child {
    position: absolute;

    right: 0;
  }
`

const ProfileGrid = (props) => {
  const {t} = useTranslate()
  const history = useHistory()
  const {user} = props
  const firstName = path(['user', 'firstName'], user)
  const lastName = path(['user', 'lastName'], user)
  const photoUrl = path(['user', 'photoUrl'], user)
  const isPremium = path(['user', 'isPremium'], user)

  const getBalance = useFetch({
    action: getBalanceAction,
    stateName: STATES.GET_BALANCE,
    childIsNull: true
  })

  const loading = path(['loading'], getBalance)
  const balance = path(['data', 'balance'], getBalance) || []

  const menus = [
    {
      title: 'my_orders',
      icon: <img src={card} alt={''}/>,
      onClick: () => history.push(HISTORY_PATH)
    },
    {
      title: 'pending_orders',
      icon: <img src={card} alt={''}/>,
      onClick: () => history.push({
        pathname: HISTORY_PATH,
        search: '?status=pending'
      })
    },
    {
      title: 'create_order',
      icon: <Plus size={20} color={'#333333'}/>,
      onClick: () => history.push(ROOT_PATH)
    },
    {
      title: 'exit',
      icon: <LogOut size={20} color={'#ec3942'} />,
      onClick: () => window.Telegram.WebApp.close()
    }
  ]

  return (
    <Container
      top={'74px'}
      hasStatusBar
    >
      {
        loading ? (
          <Loader />
        ) : (
          <>
            <Bar>
              <Photo>
                <img src={photoUrl} alt={''}/>
              </Photo>
              <Right>
                <Name>
                  {firstName} {lastName} {isPremium ? <img src={tgPremium} alt={''} /> : null}
                </Name>
                <Balance>
                  {t('balance')}:
                  {
                    mapIndexed((item, index) => {
                      const totalAmount = path(['totalAmount'], item)
                      const currencyName = path(['currencyName'], item)

                      return (
                        <p key={index}>
                          {formatNumber(totalAmount, currencyName, ' ')}
                          {index !== balance.length - 1 ? ',' : ''}
                        </p>
                      )
                    }, balance)
                  }
                </Balance>
              </Right>
            </Bar>
            <Menus>
              {
                mapIndexed((item) => {
                  const {title, icon, onClick} = item
                  return (
                    <Menu onClick={onClick && onClick}>
                      {icon}
                      <p style={{color: title === 'exit' ? '#ec3942' : '#2E384C'}}>{t(title)}</p>
                      <ChevronRight size={20} stroke={'#B8BBC2'}/>
                    </Menu>
                  )
                }, menus)
              }
            </Menus>
          </>
        )
      }
    </Container>
  )
}

ProfileGrid.propTypes = {
  user: PropTypes.object.isRequired
}

export default ProfileGrid
